import { t } from "@lingui/macro";
import graphql from "babel-plugin-relay/macro";
import { useAtomValue } from "jotai";
import React from "react";
import { useFragment } from "react-relay";

import { currentProfileAtom } from "@/features/Club/atoms";
import { HoleCountIcon } from "@whoosh/design-system/src/components/icons_v2/courseLayout/icons/HoleCountIcon";
import { TeeSheetTransportationIcon } from "@whoosh/design-system/src/components/icons_v2/transportation";
import { HStack } from "@whoosh/design-system/src/components/primitive";
import { Text } from "@whoosh/design-system/src/components/primitive";

import { EventDetailPairingsRound_round$key } from "./__generated__/EventDetailPairingsRound_round.graphql";

export const EventDetailPairingsRound = ({
  round,
}: {
  round?: EventDetailPairingsRound_round$key | null;
}) => {
  const currentMemberId = useAtomValue(currentProfileAtom)?.memberId;
  const roundData = useFragment(EventDetailPairingsRoundFragment, round);
  if (!roundData) return null;

  return (
    <HStack
      key={roundData?.player?.id}
      gap={1}
      alignItems="center"
      flex={1}
      testID="event-detail-pairings-round"
    >
      <HStack backgroundColor="grayscale-200" padding={1} borderRadius="2">
        <TeeSheetTransportationIcon
          transportationType={roundData?.transportationType?.code ?? "WALK"}
        />
        <HoleCountIcon
          holeCount={roundData?.courseLayout?.holeCount ?? "NONE"}
        />
      </HStack>
      <Text
        variant="mainSmallSemiBold"
        testID={`event-detail-pairings-round-player-${roundData?.player?.firstName?.toLowerCase()}-${roundData?.player?.lastName?.toLowerCase()}`}
      >
        {roundData?.player?.firstName} {roundData?.player?.lastName}{" "}
        {roundData?.player?.id === currentMemberId ? t`(You)` : ""}
      </Text>
    </HStack>
  );
};

export const EventDetailPairingsRoundFragment = graphql`
  fragment EventDetailPairingsRound_round on Round {
    player {
      id
      firstName
      lastName
    }
    transportationType {
      code
    }
    courseLayout {
      holeCount
    }
  }
`;
